import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
//import { DataContextService } from '@shared/services/data-context-service.service';
//import { formArrayNameProvider } from '@angular/forms/src/directives/reactive_directives/form_group_name';
import { NgForm } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import {Subject} from 'rxjs';
import { MasterService } from 'src/app/shared/services/master.service';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { OfficesService } from 'src/app/shared/services/offices.service';
import { city } from 'src/app/shared/classes/city';
import { Country } from 'src/app/shared/classes/Country';
import { HttpClient } from '@angular/common/http';
import { City } from 'src/app/shared/classes/users';
import { ToastrService } from 'ngx-toastr';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';

@Component({
  selector: 'app-add-office',
  templateUrl: './add-office.component.html',
  styleUrls: ['./add-office.component.less']
})

export class AddOfficeComponent implements OnInit, OnDestroy {
  public cityData: city[] = [];
  public cityList: any = [];
  public CountryData:Country[] = [];
  CountrySelected:number;
  CitySelected: number;
  cityName: string;
  MasterList: any = [];
  OfficeAddress:string;
  Status:any;
  selectActiveStatus: {isChecked: boolean} = {isChecked : true};
  selectInActiveStatus: {isChecked: boolean} = {isChecked : false};
  private service_URL: any;
  private unsubscribe$ =new Subject<void>();
  @ViewChild('addOfficeForm') addOfficeForm: NgForm;
  constructor(
    private _dataContextService: DataContextService,
    private _masterService: MasterService,
    public modalRef: BsModalRef,
    private httpClient : HttpClient,
    private toast: ToastrService,
    private officeService: OfficesService,
    private loaderService: LoaderService,
    private trackeromnitureservice:TrackerOmnitureService
  ) {
    this.service_URL = ConstantsService;
  }

  ngOnInit() {
    this.getData();
    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('office-add',username);
    this.trackeromnitureservice.trackPage("pageView");
    setTimeout(() => {
        //console.log(this.MasterList)

        //Add Countries to CountryData List
        for(var i=0;i<this.MasterList.length;i++){
          var _cd = new Country();
          _cd.countryId = this.MasterList[i].countryID;
          _cd.countryName = this.MasterList[i].countryName;

          this.CountryData.push(_cd);
        }
    }, 3000);
  }

  OnchangeCountry(event){
    this.cityData = [];
    this.cityList=this.MasterList.filter((item)=>
    {  
      return item.countryID == event
    })
    var obj = this.cityList[0];
    
    obj.cityList.forEach(element => {
      var _cy = new city();
      _cy.cityId = element.cityID;
      _cy.cityName = element.cityName;
      _cy.countryId = element.countryID;

      this.cityData.push(_cy);
    });
  }

  AddNewOffice(office) {
    //Converting selected status to boolean
    if (this.addOfficeForm.valid) {
      if (this.selectActiveStatus.isChecked) {
        this.Status = true;
      }
      else {
        this.Status = false;
      }

      //Finding object of selected country
      var co = this.CountryData.find(obj => obj.countryId = this.CountrySelected);
      //Finding object of selected city
      var ci = this.cityData.find(obj => obj.cityId = this.CitySelected);

      //Fetching user name from local storage
      var userName = localStorage.getItem('email');

      //Params for POST request
      let params = {
        OfficeName: office,
        OfficeAddress:this.OfficeAddress,
        PostWorkingHour: 8,
        CityID: this.CitySelected,
        CityName: ci.cityName,
        AddedBy: userName,
        IsActive: this.Status,
        CountryID: this.CountrySelected,
        CountryName: co.countryName,
        CCMail: userName
      };
      
      //Add Office API
      this._dataContextService.postDatawithValues<any>(this.service_URL.OfficeDetails.NewOffice, params)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        this.modalRef.hide();
        this.loaderService.show();
        this.officeService.refreshwithFilters.next();
        this.toast.success("Successfully added office details!");
      });
    }
    else {
      this.toast.error("Unable to save office details!");
    }
}
  

  getData(){
    //OfficeMasterData API/
    this._masterService.getOfficeMasterData()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((data) => {
      this.MasterList = data;
      // console.log(data);
    })
  }

  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
